import { memo } from 'react';

import AddMembersIconSVG from '@/assets/add-members-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAddMembersIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={AddMembersIconSVG} {...props} />
);

export const AddMembersIcon = memo(IAddMembersIcon) as typeof IAddMembersIcon;
